import { Button, Checkbox, Chip, IconButton, MenuItem, Typography, List, ListItem, ListItemPrefix, Accordion, AccordionHeader, AccordionBody, Alert } from "@material-tailwind/react";
import { TextInput, Card, Select, SelectItem, Metric, Table, TableHead, TableRow, TableHeaderCell, TableBody, TableCell, Badge, Switch } from "@tremor/react";

import withDataTestId from "./withDataTestId";

export const TestableAccordion = withDataTestId(Accordion);
export const TestableAccordionBody = withDataTestId(AccordionBody);
export const TestableAccordionHeader = withDataTestId(AccordionHeader);
export const TestableAlert = withDataTestId(Alert);

export const TestableBadge = withDataTestId(Badge);
export const TestableButton = withDataTestId(Button);
export const TestableCard = withDataTestId(Card);
export const TestableCheckbox = withDataTestId(Checkbox);
export const TestableChip = withDataTestId(Chip);
export const TestableIconButton = withDataTestId(IconButton);

export const TestableList = withDataTestId(List);
export const TestableListItem = withDataTestId(ListItem);
export const TestableListItemPrefix = withDataTestId(ListItemPrefix);

export const TestableMenuItem = withDataTestId(MenuItem);
export const TestableMetric = withDataTestId(Metric);

export const TestableSelect = withDataTestId(Select);
export const TestableSelectItem = withDataTestId(SelectItem);
export const TestableSwitch = withDataTestId(Switch);

export const TestableTable = withDataTestId(Table);
export const TestableTableBody = withDataTestId(TableBody);
export const TestableTableCell = withDataTestId(TableCell);
export const TestableTableHead = withDataTestId(TableHead);
export const TestableTableHeaderCell = withDataTestId(TableHeaderCell);
export const TestableTableRow = withDataTestId(TableRow);

export const TestableText = withDataTestId(Typography);
export const TestableTextInput = withDataTestId(TextInput);